import { create } from 'zustand';

// Plain success notes ("Customer ACME created") that need no answer: a toast
// instead of a modal that takes focus and must be dismissed (forms-missed-04).
// Keep dialog.success where the message IS the result (a document number to
// copy) and for security notices.
export type ToastItem = { id: number; message: string; tone: 'success' | 'info'; action?: { label: string; onClick: () => void } };
export const TOAST_MS = 4000;
const MAX = 3;
let seq = 0;

type State = {
  toasts: ToastItem[];
  push: (t: Omit<ToastItem, 'id'>) => number;
  dismiss: (id: number) => void;
};

export const useToastStore = create<State>((set) => ({
  toasts: [],
  push: (t) => {
    const id = ++seq;
    set((s) => ({ toasts: [...s.toasts, { ...t, id }].slice(-MAX) }));
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));

export const toast = {
  success: (message: string) => useToastStore.getState().push({ message, tone: 'success' }),
  info: (message: string, action?: ToastItem['action']) => useToastStore.getState().push({ message, tone: 'info', action }),
};
